import { setValueOnPath } from 'tools/helpers/math';

function guessValueType(value: any) {
	if (value === 'true') return true;

	if (value === 'false') return false;

	return value;
}

export class UrlBuilder {
	params: Record<string, string> = {};
	path = '';

	constructor(query: string) {
		let parts = query.split('#');
		parts = parts[0].split('?');
		this.path = parts[0];

		if (this.path.length > 1 && this.path[this.path.length - 1] == '/') {
			this.path = this.path.substring(0, this.path.length - 1);
		}

		if (parts.length > 1) {
			parts[1].split('&').forEach((p) => {
				const parameterParts = p.split('=');
				setValueOnPath(this.params, parameterParts[0], guessValueType(decodeURIComponent(parameterParts[1])));
			});
		}
	}

	add<TValue extends { toString: () => string }>(key: string | object, value?: TValue, condition = true) {
		if (typeof key == 'object') {
			return this.addObject(key);
		}

		if (condition === false || !key) return this;

		if (value !== null && value !== undefined) {
			this.params[key] = encodeURIComponent(value.toString());
		}

		return this;
	}

	addObject(object: object, prefix = '') {
		if (!object) return this;

		for (const [key, value] of Object.entries(object)) {
			if (typeof value == 'object') {
				this.addObject(value, prefix + key + '.');
			} else {
				this.add(prefix + key, value);
			}
		}
		return this;
	}

	getQuery() {
		const inlineParams = this.inlineParams();
		return Object.entries(this.params)
			.map(([key, value]) => {
				if (!(value === null || value === undefined || inlineParams.includes(key))) {
					return key + '=' + value;
				}
			})
			.filter((x) => !!x)
			.join('&');
	}

	addPath(pathEntry: string, condition = true) {
		if (condition) {
			this.path = this.path + '/' + pathEntry;
		}
		return this;
	}

	build() {
		let url = this.filledUrl();
		const query = this.getQuery();
		if (query != '') {
			url = url + '?' + query;
		}

		return url;
	}

	filledUrl() {
		let url = this.path;
		const inlineParams = this.inlineParams();
		inlineParams.forEach((key) => {
			url = url.replace(`:${key}`, this.params[key]);
		});
		return url;
	}

	inlineParams() {
		return this.path
			.split('/')
			.filter((x) => x && x[0] === ':')
			.map((x) => x.replace(':', ''));
	}
}

export function getUrlBuilderForCurrentHash() {
	return new UrlBuilder(window.location.hash.split('#').pop());
}

export function getParameterFromCurrentHash(name: string) {
	const builder = getUrlBuilderForCurrentHash();
	return builder.params[name];
}

export function getUrlBuilderForCurrentUrl() {
	return new UrlBuilder(window.location.href);
}

export default UrlBuilder;
